import { render, staticRenderFns } from "./PostTypeList.vue?vue&type=template&id=3ec04568&scoped=true&"
import script from "./PostTypeList.vue?vue&type=script&lang=js&"
export * from "./PostTypeList.vue?vue&type=script&lang=js&"
import style0 from "./PostTypeList.vue?vue&type=style&index=0&id=3ec04568&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec04568",
  null
  
)

export default component.exports